<template>
  <v-container fluid class="mb-12 pb-8">
    <v-progress-linear
      v-if="$vars.loading"
      indeterminate
      class="primary--text loader"
    ></v-progress-linear>
    <v-row class="ma-2" :no-gutters="$vuetify.breakpoint.xsOnly">
      <v-col cols="12" sm="6" md="4" lg="4" xl="3" v-for="submodul in submodule" :key="submodul.id" class="pa-1">
        <chargen v-if="submodul.value === 'chargen'" :vorstand="submodul.props[0].wert" :showTitle="true"></chargen>
        <geburtstage v-if="submodul.value === 'geburtstage'"></geburtstage>
        <jubilaum v-if="submodul.value === 'jubilaum'" :semester="submodul.props[0].wert"></jubilaum>
        <kontakteStatus v-if="submodul.value === 'kontakteStatus'" :status="submodul.props[0].wert"></kontakteStatus>
        <mailsListe v-if="submodul.value === 'mailsListe'" :bbr="currentBbr"></mailsListe>
        <rechnungenEigene v-if="submodul.value === 'rechnungenEigene'" :bbr="currentBbr"></rechnungenEigene>
        <rechnungenStatus v-if="submodul.value === 'rechnungenStatus'" :kasse="submodul.props[0].wert" :status="submodul.props[1].wert"></rechnungenStatus>
        <ripuaren v-if="submodul.value === 'ripuaren'"></ripuaren>
        <todosEigene v-if="submodul.value === 'todosEigene'"></todosEigene>
        <veranstaltungenListe v-if="submodul.value === 'veranstaltungenListe'" anzahl="5"></veranstaltungenListe>
        <bundesbruderSuche v-if="submodul.value === 'bundesbruderSuche'"></bundesbruderSuche>
        <bierranking v-if="submodul.value === 'bierranking'"></bierranking>
        <schankverlust v-if="submodul.value === 'schankverlust'"></schankverlust>
        <rechnungSuche v-if="submodul.value === 'rechnungSuche'"></rechnungSuche>
        <keilkandidaten v-if="submodul.value === 'keilkandidaten'"></keilkandidaten>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: ['submodule'],
    data () {
      return {
        search: ''
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// uebersicht.vue?5f5bd638